
import { useState, useEffect } from 'react';
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HeroSection from "@/components/team/HeroSection";
import TeamMembersSection from "@/components/team/TeamMembersSection";
// import ExpertiseSection from "@/components/team/ExpertiseSection";
import CTASection from "@/components/team/CTASection";
import federicoPhoto from "@/assets/federico.jpg";
import marcoPhoto from "@/assets/marco.jpg";

const contactInfo = {
  coFounders: [
    {
      name: "Federico Marioni",
      position: "Co-Founder & CEO",
      bio: "With over 15 years of experience in software development and AI, Marco leads our strategic vision and oversees all aspects of the company's operations.",
      image: federicoPhoto,
      calendly: "https://calendly.com/marcomarioni",
      social: {
        linkedin: "https://linkedin.com"
      }
    },
    {
      name: "Marco Marioni",
      position: "Co-Founder & CTO",
      bio: "Federico brings deep technical expertise in artificial intelligence and machine learning, ensuring our solutions leverage the latest advancements in technology.",
      image: marcoPhoto,
      calendly: "https://calendly.com/federicomarioni",
      social: {
        linkedin: "https://linkedin.com"
      }
    }
  ]
};

const OurTeam = () => {
  const [heroVisible, setHeroVisible] = useState(false);
  const [teamVisible, setTeamVisible] = useState(false);
  
  const [expertiseVisible, setExpertiseVisible] = useState(false);
  
  useEffect(() => {
    window.scrollTo(0, 0);
    setHeroVisible(true);
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (entry.target.id === 'team-members') {
              setTeamVisible(true);
            } else if (entry.target.id === 'expertise') {
              setExpertiseVisible(true);
            }
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    
    const teamElement = document.getElementById('team-members');
    const expertiseElement = document.getElementById('expertise');
    
    if (teamElement) observer.observe(teamElement);
    if (expertiseElement) observer.observe(expertiseElement);
    
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection heroVisible={heroVisible} />
      <TeamMembersSection teamVisible={teamVisible} coFounders={contactInfo.coFounders} />
      
      {/* Our Collective Expertise (hidden) */}
      {/* <ExpertiseSection expertiseVisible={expertiseVisible} /> */}
      <CTASection />
      <Footer />
    </div>
  );
};

export default OurTeam;
